export function mergePresetColumns() {
    var basePreset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], patchColumns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var result = [];
    var insertedKeys = new Set();
    var removedKeys = new Set();
    var beforeMap = {};
    var afterMap = {};
    var overrideMap = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = patchColumns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var col = _step.value;
            if (col.remove) {
                removedKeys.add(col.key);
            } else if (col.insertBefore) {
                var _beforeMap, _col_insertBefore;
                var _;
                (_ = (_beforeMap = beforeMap)[_col_insertBefore = col.insertBefore]) !== null && _ !== void 0 ? _ : _beforeMap[_col_insertBefore] = [];
                beforeMap[col.insertBefore].push(col);
            } else if (col.insertAfter) {
                var _afterMap, _col_insertAfter;
                var _1;
                (_1 = (_afterMap = afterMap)[_col_insertAfter = col.insertAfter]) !== null && _1 !== void 0 ? _1 : _afterMap[_col_insertAfter] = [];
                afterMap[col.insertAfter].push(col);
            } else {
                overrideMap[col.key] = col;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = basePreset[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var baseCol = _step1.value;
            var key = baseCol.key;
            if (removedKeys.has(key)) continue;
            if (beforeMap[key]) {
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = beforeMap[key][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var beforeCol = _step2.value;
                        if (!insertedKeys.has(beforeCol.key)) {
                            result.push(beforeCol);
                            insertedKeys.add(beforeCol.key);
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            if (overrideMap[key]) {
                result.push(overrideMap[key]);
                insertedKeys.add(key);
            } else {
                result.push(baseCol);
            }
            if (afterMap[key]) {
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = afterMap[key][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var afterCol = _step3.value;
                        if (!insertedKeys.has(afterCol.key)) {
                            result.push(afterCol);
                            insertedKeys.add(afterCol.key);
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
    try {
        // handle insert-only (not tied to before/after or override)
        for(var _iterator4 = patchColumns[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
            var col1 = _step4.value;
            if (!insertedKeys.has(col1.key) && !removedKeys.has(col1.key) && !col1.insertBefore && !col1.insertAfter) {
                result.push(col1);
                insertedKeys.add(col1.key);
            }
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
            }
        } finally{
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }
    return result;
}
